import { CivilUnionDetailAnscNotificationsResidentSubscriptionCrumbs } from 'subscription/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import RegistrationCivilUnionDetailAnscNotificationShared from 'shell/components/shared/ansc-notifications/research-civil-union/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const RegistrationCivilUnionDetailAnscNotificationPage = (): ReactElement => {
  return (
    <Fragment>
      <RegistrationCivilUnionDetailAnscNotificationShared
        items={CivilUnionDetailAnscNotificationsResidentSubscriptionCrumbs()}
        scope={IdAmbito.Iscrizioni}
      />
    </Fragment>
  );
};

RegistrationCivilUnionDetailAnscNotificationPage.displayName =
  'Research Civil Union Detail Notifications CivilStatusPage component';

export default RegistrationCivilUnionDetailAnscNotificationPage;
